<div class="forgotten-password-container">
    <form #forgottenPasswordForm="ngForm" class="form-forgotten-password" (ngSubmit)="forgottenPasswordForm.form.valid
    && requestResetPassword()" novalidate>
        <h1 class="h3 mb-3 font-weight-normal">Forgotten Password</h1>
        <p>Please submit your email address to receive an email with a link to reset your password.</p>
        <div class="form-group">
             <label for="emailAddress">Email address *</label>
             <input type="email" class="form-control" id="emailAddress" required email
                    placeholder="Enter your email address"
                    [(ngModel)]="emailAddressToReset" name="emailAddress"
                    #emailAddress="ngModel">
             <div [hidden]="emailAddress.valid || emailAddress.pristine"
                  class="alert alert-danger">
                 A valid email address is required
             </div>
        </div>
        <!-- GENERIC ERROR -->
        <div class="form-group" *ngIf="requestResetFail">
            <div class="alert alert-danger">
                Something went wrong when requesting a reset of your password.
                Please try again. If the problem persists, please <a routerLink="/contact">contact us</a>.
            </div>
        </div>
        <!-- ERROR: 404 - EMAIL NOT FOUND -->
       <div class="form-group" *ngIf="requestResetFailNoUserFound">
            <div class="alert alert-danger">
                No account exists for email address {{ emailAddressToReset }}.
                Please <a routerLink="/register">register</a> for an account first.
            </div>
        </div>
        <!-- SUCCESS -->
        <div class="form-group" *ngIf="requestResetSuccess">
            <div class="alert alert-primary">
                A link to reset your password has been sent to {{ emailAddressToReset }}.
            </div>
        </div>
        <div class="form-group">
            <button class="btn btn-lg btn-primary btn-block" type="submit"
                    [disabled]="!forgottenPasswordForm.form.valid || requestResetSuccess">
                Submit
            </button>
        </div>
    </form>
</div>